'use client';

import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

export type TimeRange = '1W' | '1M' | '3M' | '6M' | '1Y' | 'ALL';

interface TimeRangeControlsProps {
  value: TimeRange;
  onChange: (value: TimeRange) => void;
}

export function TimeRangeControls({ value, onChange }: TimeRangeControlsProps) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, newValue) => newValue && onChange(newValue)}
      size="small"
    >
      <ToggleButton value="1W">1W</ToggleButton>
      <ToggleButton value="1M">1M</ToggleButton>
      <ToggleButton value="3M">3M</ToggleButton>
      <ToggleButton value="6M">6M</ToggleButton>
      <ToggleButton value="1Y">1Y</ToggleButton>
      <ToggleButton value="ALL">ALL</ToggleButton>
    </ToggleButtonGroup>
  );
}
